import React, { useEffect, useRef, useState } from 'react';

import cn from 'classnames';

import { formatPrice } from '@shared/helpers';
import { IEstimate } from '@widgets/EstimateInformation/model/types/types';

import cls from './SingleEstimateLink.module.css';

interface SingleEstimateLinkProps {
    isShowAllEstimates?: boolean;
    estimate: IEstimate;
}

export const SingleEstimateLink = ({ isShowAllEstimates, estimate }: SingleEstimateLinkProps) => {
    const formatedCont = formatPrice(+estimate.cost, {
        maximumFractionDigits: 2,
        minimumFractionDigits: 0,
        withCurrency: false,
    });

    const title = `${estimate.name}. ${formatedCont} ${estimate.currencySign}`;

    const estimateRef = useRef<HTMLDivElement | null>(null);

    const [isEstimateTruncated, setIsEstimateTruncated] = useState(false);

    const checkTruncate = () => {
        const el = estimateRef.current;
        if (!el) return;

        setIsEstimateTruncated(el.scrollWidth > el.clientWidth);
    };

    useEffect(() => {
        checkTruncate();
    }, [checkTruncate, estimate]);

    useEffect(() => {
        const el = estimateRef.current;
        if (!el) return;

        const ro = new ResizeObserver(() => checkTruncate());
        ro.observe(el);

        return () => ro.disconnect();
    }, [checkTruncate]);
    return (
        <div
            ref={estimateRef}
            className={cn(cls.estimatesEllipsis, isShowAllEstimates && cls.showAllEstimates)}
        >
            <a
                title={isEstimateTruncated ? title ?? '' : undefined}
                href={estimate.url}
                className={cn(cls.estimateLink, isShowAllEstimates && cls.showAllEstimates)}
            >
                {title}
            </a>
        </div>
    );
};
